// Local graphics pack (assets/graphics, served through /hyperframes/assets).
// The previous pack pointed at a dead CDN; these are generated by
// scripts/generate-graphics-pack.mjs and committed with the repo.
export const GRAPHICS = [
  { id: "star", name: "Star", src: "/hyperframes/assets/graphics/star.svg" },
  { id: "burst", name: "Burst", src: "/hyperframes/assets/graphics/burst.svg" },
  { id: "heart", name: "Heart", src: "/hyperframes/assets/graphics/heart.svg" },
  { id: "lightning", name: "Lightning", src: "/hyperframes/assets/graphics/lightning.svg" },
  { id: "circle-solid", name: "Circle", src: "/hyperframes/assets/graphics/circle-solid.svg" },
  { id: "circle-ring", name: "Ring", src: "/hyperframes/assets/graphics/circle-ring.svg" },
  { id: "ring-dot", name: "Ring dot", src: "/hyperframes/assets/graphics/ring-dot.svg" },
  { id: "half-circle", name: "Half circle", src: "/hyperframes/assets/graphics/half-circle.svg" },
  { id: "hexagon", name: "Hexagon", src: "/hyperframes/assets/graphics/hexagon.svg" },
  { id: "blob", name: "Blob", src: "/hyperframes/assets/graphics/blob.svg" },
  { id: "chevron-right", name: "Chevron right", src: "/hyperframes/assets/graphics/chevron-right.svg" },
  { id: "chevron-up", name: "Chevron up", src: "/hyperframes/assets/graphics/chevron-up.svg" },
  { id: "arrow-right", name: "Arrow", src: "/hyperframes/assets/graphics/arrow-right.svg" },
  { id: "play-circle", name: "Play", src: "/hyperframes/assets/graphics/play-circle.svg" },
  { id: "check-badge", name: "Check", src: "/hyperframes/assets/graphics/check-badge.svg" },
  { id: "speech-bubble", name: "Speech bubble", src: "/hyperframes/assets/graphics/speech-bubble.svg" },
  { id: "quote", name: "Quote", src: "/hyperframes/assets/graphics/quote.svg" },
  { id: "price-tag", name: "Price tag", src: "/hyperframes/assets/graphics/price-tag.svg" },
  { id: "location-pin", name: "Location", src: "/hyperframes/assets/graphics/location-pin.svg" },
  { id: "bars-chart", name: "Chart bars", src: "/hyperframes/assets/graphics/bars-chart.svg" },
  { id: "mountains", name: "Mountains", src: "/hyperframes/assets/graphics/mountains.svg" },
  { id: "wave-lines", name: "Waves", src: "/hyperframes/assets/graphics/wave-lines.svg" },
  { id: "dots-grid", name: "Dots", src: "/hyperframes/assets/graphics/dots-grid.svg" },
  { id: "frame-corners", name: "Corners", src: "/hyperframes/assets/graphics/frame-corners.svg" },
]
